import React from "react";
import { Div, Text, Button, scrollTo } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import CreatorsModal from "../../modals/CreatorsModal";

class InfluencersApply extends React.Component {
  // state = { showModal: false };

  render() {
    const { title } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { md: "0", lg: "2.5rem" } }}>
          <Div className="influencers-apply" p={{ b: "2rem" }}>
            <Div>
              <Text
                className="apply-text"
                textSize={{ lg: "display4", xs: "caption4" }}
                textWeight="700"
                tag="h2"
                dangerouslySetInnerHTML={{
                  __html: title.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                }}
              ></Text>
              <Button
                className="apply-button"
                p={{ xs: "0", lg: "0 0 3.2rem 0" }}
                m={{ t: ".5rem" }}
                h={{ xs: "2.5rem", md: "4rem" }}
                textWeight="700"
                // onClick={() => this.setState({ showModal: true })}
                onClick={() => scrollTo("#creators-hero")}
                textSize={{ lg: "display4", xs: "caption4" }}
              >
                Apply Now
              </Button>
            </Div>
          </Div>
        </CustomContainer>
        {/* <CreatorsModal
          isOpen={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        /> */}
      </WebsiteContainer>
    );
  }
}

export default InfluencersApply;
